import { CFormInputProps } from '@coreui/react-pro/dist/components/form/CFormInput'

import { OrganizationServicesQueryElement } from '@interfaces/general'

export enum TypeOfService {
  individual = 'Individual psychotherapy',
  crisis = 'Crisis psychotherapy',
  group = 'Group psychotherapy',
}

export interface ITypeOfServiceDropDown {
  inputProps?: CFormInputProps & React.RefAttributes<HTMLInputElement>
  onChange: (option?: OrganizationServicesQueryElement) => void
  selectedService?: OrganizationServicesQueryElement
  includeCustomServices?: boolean
  separateCptAndAddons?: boolean
  showDescription?: boolean
  autoSelectDefault?: boolean
}
